import { render, staticRenderFns } from "./BatchDetails.vue?vue&type=template&id=4d8d47ae&scoped=true"
import script from "./BatchDetails.vue?vue&type=script&lang=js"
export * from "./BatchDetails.vue?vue&type=script&lang=js"
import style0 from "./BatchDetails.vue?vue&type=style&index=0&id=4d8d47ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d47ae",
  null
  
)

export default component.exports